import React from 'react'
import AccountInfoPreview from '../../components/AccountInfoBar/AccountInfoPreview'
import { MessageCenter } from '../../components/MessageCenter'
import appLayoutStyles from '../AppLayout/styles.module.less'
import CounterPartyDetailsPreview from './CounterPartyDetailsPreview'
import EditOrSubmitTrade from './EditOrSubmitTrade'
import FeesPreview from './FeesPreview'
import styles from './styles.module.less'
import TradeCalculations from './TradeCalculations'
import TradeDetailsPreview from './TradeDetailsPreview'
import { TradeFormProps } from './TradeForm'
import TradeInstructionsPreview from './TradeInstructionsPreview'

const TradePreview = ({
  accountDetails,
  correspondent,
  onModeButtonClick,
  onSubmit,
  tradeSubmissionFailedMessage,
  values,
}: TradeFormProps) => (
  <div className={`trade-preview ${styles.tradePreview}`}>
    {tradeSubmissionFailedMessage && (
      <div className={appLayoutStyles.offsetBar}>
        <MessageCenter errorMessages={[tradeSubmissionFailedMessage]} />
      </div>
    )}
    <AccountInfoPreview accountDetails={accountDetails} correspondent={correspondent} values={values} />
    <EditOrSubmitTrade onModeButtonClick={onModeButtonClick} onSubmit={onSubmit} />
    <TradeDetailsPreview values={values} />
    <CounterPartyDetailsPreview values={values} />
    <FeesPreview values={values} />
    <TradeCalculations values={values} accountDetails={accountDetails} />
    <TradeInstructionsPreview values={values} />
    <EditOrSubmitTrade onModeButtonClick={onModeButtonClick} onSubmit={onSubmit} />
  </div>
)

export default TradePreview
